import * as React from 'react'

interface ITripsDetailsMapProps {
  [index: string]: any
}

const TripDetailsMap = (props: ITripsDetailsMapProps) => {
  return (
    <div style={{ height: '5rem' }} className='mt2 mb1 border'>
      Map
    </div>
  )
}

export default TripDetailsMap



// WEBPACK FOOTER //
// ./src/components/trips/TripDetailsMap.tsx